import React from 'react';
import Edit from './Edit';
import Forward from './Forward';
import Backward from './Backward';
import Close from './Close';
import Download from './Download';
import Download2 from './Download2';
import Success from './Success';
import Add from './Add';
import Delete from './Delete';
import Plus from './Plus';
import Minus from './Minus';
import Upload from './Upload';
import SuccessFilled from './SuccessFilled';
import EditorLoader from './EditorLoader';
import Loader from './Loader';
import AILogo from './AILogo';
import AILogoGradient from './AILogoGradient';
import File from './File';
import ArrowRight from './ArrowRight';
import Bin from './Bin';
import LabelAILogo from './LabelAILogo';
import LabelExpertLogo from './LabelExpertLogo';
import ExpertLogo from './ExpertLogo';
import AIInputLogo from './AIInputLogo';
import AIInputSend from './AIInputSend';
import ContentPaste from './ContentPaste';
import UploadFile from './UploadFile';
import Document from './Document';
import AIIcon from './AIIcon';
import Lock from './Lock';
import Done from './Done';
import Person from './Person';
import ToolsIcon from './ToolsIcon';
import Crown from './Crown';
import Check from './Check';
import PlagiarismPaste from './PlagiarismPaste';
import PlagiarismUpload from './PlagiarismUpload';
import ToastError from './ToastError';
import PlagiarismCheck from './PlagiarismCheck';
import PlagiarismClear from './PlagiarismClear';
import PlagiarismDetectAI from './PlagiarismDetectAI';
import ExternalLink from './ExternalLink';
import Copy from './Copy';
import BorderedError from './BorderedError';
import ChartArcs from './ChartArcs';
import CheckedList from './CheckedList';
import Info from './Info';
import LightBulb from './LightBulb';
import Eye from './Eye';
import EyeOff from './EyeOff';
import LabelAIBordered from './LabelAIBordered';
import Lightning from './Lightning';
import Warning from './Warning';
import AcademicCap from './AcademicCap';
import Briefcase from './Briefcase';
import Send from './Send';
import TextBold from './TextBold';
import TextItalic from './TextItalic';
import TextUnderline from './TextUnderline';
import TextHighlight from './TextHighlight';
import ListBulleted from './ListBulleted';
import ListOrdered from './ListOrdered';
import TextUndo from './TextUndo';
import TextRedo from './TextRedo';
import TextPaste from './TextPaste';
import UploadFileV2 from './UploadFileV2';
import Heading from './Heading';
import Layers from './Layers';
import Code from './Code';
import Scan from './Scan';
import Expand from './Expand';
import Collapse from './Collapse';
import Like from './Like';
import Dislike from './Dislike';
import LikeFilled from './LikeFilled';
import DislikeFilled from './DislikeFilled';
import FactChecker from './FactChecker';
import GrammarChecker from './GrammarChecker';
import Rescan from './Rescan';
import CrossCircle from './CrossCircle';
import Secure from './Secure';
import Incognito from './Incognito';
import Unlock from './Unlock';
import Ai from './Ai';
import Warning2 from './Warning2';
import ImproveText from './ImproveText';
import Ask from './Ask';
import ChatGpt from './ChatGpt';
import Claude from './Claude';
import Gemini from './Gemini';
import Check2 from './Check2';
import CheckMark from './CheckMark';
import DocumentEdit from './DocumentEdit';
import ClockPlus from './ClockPlus';
import Clock from './Clock';
import AlarmClock from './AlarmClock';
import DocumentText from './DocumentText';
import EditSquare from './EditSquare';
import Search from './Search';
import Settings from './Settings';
import Humanizer from './Humanizer';
import AiChat from './AiChat';
import DocumentSparkle from './DocumentSparkle';
import Microphone from './Microphone';
import LinesSparkle from './LinesSparkle';
import DocumentReload from './DocumentReload';
import Clip from './Clip';
import ChevronDown from './ChevronDown';
import UnlockOpen from './UnlockOpen';
import ChevronsRight from './ChevronsRight';
import NavAllTools from './NavAllTools';
import NavHumanizer from './NavHumanizer';
import NavDetector from './NavDetector';
import NavPlagiarism from './NavPlagiarism';
import NavGrammar from './NavGrammar';
import NavAiChat from './NavAiChat';
import NavExpertHelp from './NavExpertHelp';
import NavHistory from './NavHistory';
import More from './More';
import Burger from './Burger';
import Cycle from './Cycle';
import InfinitySign from './InfinitySign';
import FileLines from './FileLines';
import Sparkles from './Sparkles';
import SearchSparkle from './SearchSparkle';
import PuzzlePlus from './PuzzlePlus';
import LockKeyholeOpen from './LockKeyholeOpen';
import PenSparkle from './PenSparkle';

export enum IconGlyph {
  EDIT = 'edit',
  FORWARD = 'forward',
  BACKWARD = 'backward',
  CLOSE = 'close',
  DOWNLOAD = 'download',
  DOWNLOAD2 = 'download2',
  SUCCESS = 'success',
  ADD = 'add',
  DELETE = 'delete',
  PLUS = 'plus',
  MINUS = 'minus',
  UPLOAD = 'upload',
  SUCCESS_FILLED = 'success-filled',
  EDITOR_LOADER = 'editor-loader',
  LOADER = 'loader',
  AI_LOGO = 'ai-logo',
  EXPERT_LOGO = 'expert-logo',
  AI_LOGO_GRADIENT = 'ai-logo-gradient',
  FILE = 'file',
  ARROW_RIGHT = 'arrow-right',
  BIN = 'bin',
  LABEL_AI_LOGO = 'label-ai-logo',
  LABEL_EXPERT_LOGO = 'label-expert-logo',
  AI_INPUT_LOGO = 'ai-input-logo',
  AI_INPUT_SEND = 'ai-input-send',
  CONTENT_PAST = 'content-past',
  UPLOAD_FILE = 'upload-file',
  DOCUMENT = 'document',
  AI_ICON = 'ai-icon',
  LOCK = 'lock',
  DONE = 'done',
  PERSON = 'person',
  TOOLS_ICON = 'tools-icon',
  CROWN = 'crown',
  CHECK = 'check',
  CHECK2 = 'check2',
  PLAGIARISM_PASTE = 'plagiarism-paste',
  PLAGIARISM_UPLOAD = 'plagiarism-upload',
  TOAST_ERROR = 'toast-error',
  PLAGIARISM_CHECK = 'plagiarism-check',
  PLAGIARISM_CLEAR = 'plagiarism-clear',
  PLAGIARISM_DETECT_AI = 'plagiarism-detect-ai',
  EXTERNAL_LINK = 'external-link',
  COPY = 'copy',
  BORDERED_ERROR = 'bordered-error',
  CHART_ARCS = 'chart-arcs',
  CHECKED_LIST = 'checked-list',
  INFO = 'info',
  LIGHT_BULB = 'light-bulb',
  EYE = 'eye',
  EYE_OFF = 'eye-off',
  LABEL_AI_BORDERED = 'label-ai-bordered',
  LIGHTNING = 'lightning',
  WARNING = 'warning',
  WARNING2 = 'warning2',
  ACADEMIC_CAP = 'academic-cap',
  BRIEFCASE = 'briefcase',
  SEND = 'send',
  TEXT_BOLD = 'text-bold',
  TEXT_ITALIC = 'text-italic',
  TEXT_UNDERLINE = 'text-underline',
  TEXT_HIGHLIGHT = 'text-highlight',
  LIST_BULLETED = 'list-bulleted',
  LIST_ORDERED = 'list-ordered',
  TEXT_UNDO = 'text-undo',
  TEXT_REDO = 'text-redo',
  TEXT_PASTE = 'text-paste',
  UPLOAD_FILE_V2 = 'upload-file-v2',
  HEADING = 'heading',
  LAYERS = 'layers',
  CODE = 'code',
  SCAN = 'scan',
  EXPAND = 'expand',
  COLLAPSE = 'collapse',
  LIKE = 'like',
  LIKE_FILLED = 'like-filled',
  DISLIKE = 'dislike',
  DISLIKE_FILLED = 'dislike-filled',
  FACT_CHECKER = 'fact-checker',
  GRAMMAR_CHECKER = 'grammar-checker',
  RESCAN = 'rescan',
  CROSS_CIRCLE = 'cross-circle',
  SECURE = 'secure',
  INCOGNITO = 'incognito',
  UNLOCK = 'unlock',
  AI = 'ai',
  IMPROVE_TEXT = 'improve-text',
  ASK = 'ask',
  CHAT_GPT = 'chat-gpt',
  CLAUDE = 'claude',
  GEMINI = 'gemini',
  SETTINGS = 'settings',
  HUMANIZER = 'humanizer',
  AI_CHAT = 'ai-chat',
  DOCUMENT_SPARKLE = 'document-sparkle',
  MICROPHONE = 'microphone',
  LINES_SPARKLE = 'lines-sparkle',
  DOCUMENT_RELOAD = 'document-reload',
  CLIP = 'clip',
  CHEVRON_DOWN = 'chevron-down',
  UNLOCK_OPEN = 'unlock-open',
  CHEVRONS_RIGHT = 'chevrons-right',
  CHECK_MARK = 'check-mark',
  DOCUMENT_EDIT = 'document-edit',
  CLOCK_PLUS = 'clock-plus',
  CLOCK = 'clock',
  ALARM_CLOCK = 'alarm-clock',
  DOCUMENT_TEXT = 'document-text',
  EDIT_SQUARE = 'edit-square',
  SEARCH = 'search',
  NAV_ALL_TOOLS = 'nav-all-tools',
  NAV_HUMANIZER = 'nav-humanizer',
  NAV_DETECTOR = 'nav-detector',
  NAV_PLAGIARISM = 'nav-plagiarism',
  NAV_GRAMMAR = 'nav-grammar',
  NAV_AI_CHAT = 'nav-ai-chat',
  NAV_EXPERT_HELP = 'nav-expert-help',
  NAV_HISTORY = 'nav-history',
  MORE = 'more',
  BURGER = 'burger',
  CYCLE = 'cycle',
  INFINITY = 'infinity',
  FILE_LINES = 'file-lines',
  SPARKLES = 'sparkles',
  SEARCH_SPARKLE = 'search-sparkle',
  PUZZLE_PLUS = 'puzzle-plus',
  LOCK_KEYHOLE_OPEN = 'lock-keyhole-open',
  PEN_SPARKLE = 'pen-sparkle',
}

const icons = {
  [IconGlyph.EDIT]: Edit,
  [IconGlyph.FORWARD]: Forward,
  [IconGlyph.BACKWARD]: Backward,
  [IconGlyph.CLOSE]: Close,
  [IconGlyph.DOWNLOAD]: Download,
  [IconGlyph.DOWNLOAD2]: Download2,
  [IconGlyph.SUCCESS]: Success,
  [IconGlyph.ADD]: Add,
  [IconGlyph.PLUS]: Plus,
  [IconGlyph.MINUS]: Minus,
  [IconGlyph.DELETE]: Delete,
  [IconGlyph.UPLOAD]: Upload,
  [IconGlyph.SUCCESS_FILLED]: SuccessFilled,
  [IconGlyph.EDITOR_LOADER]: EditorLoader,
  [IconGlyph.LOADER]: Loader,
  [IconGlyph.AI_LOGO]: AILogo,
  [IconGlyph.EXPERT_LOGO]: ExpertLogo,
  [IconGlyph.AI_LOGO_GRADIENT]: AILogoGradient,
  [IconGlyph.FILE]: File,
  [IconGlyph.ARROW_RIGHT]: ArrowRight,
  [IconGlyph.BIN]: Bin,
  [IconGlyph.LABEL_AI_LOGO]: LabelAILogo,
  [IconGlyph.LABEL_EXPERT_LOGO]: LabelExpertLogo,
  [IconGlyph.AI_INPUT_LOGO]: AIInputLogo,
  [IconGlyph.AI_INPUT_SEND]: AIInputSend,
  [IconGlyph.CONTENT_PAST]: ContentPaste,
  [IconGlyph.UPLOAD_FILE]: UploadFile,
  [IconGlyph.DOCUMENT]: Document,
  [IconGlyph.AI_ICON]: AIIcon,
  [IconGlyph.LOCK]: Lock,
  [IconGlyph.DONE]: Done,
  [IconGlyph.PERSON]: Person,
  [IconGlyph.TOOLS_ICON]: ToolsIcon,
  [IconGlyph.CROWN]: Crown,
  [IconGlyph.CHECK]: Check,
  [IconGlyph.CHECK2]: Check2,
  [IconGlyph.PLAGIARISM_PASTE]: PlagiarismPaste,
  [IconGlyph.PLAGIARISM_UPLOAD]: PlagiarismUpload,
  [IconGlyph.TOAST_ERROR]: ToastError,
  [IconGlyph.PLAGIARISM_CHECK]: PlagiarismCheck,
  [IconGlyph.PLAGIARISM_CLEAR]: PlagiarismClear,
  [IconGlyph.PLAGIARISM_DETECT_AI]: PlagiarismDetectAI,
  [IconGlyph.EXTERNAL_LINK]: ExternalLink,
  [IconGlyph.COPY]: Copy,
  [IconGlyph.BORDERED_ERROR]: BorderedError,
  [IconGlyph.CHART_ARCS]: ChartArcs,
  [IconGlyph.CHECKED_LIST]: CheckedList,
  [IconGlyph.INFO]: Info,
  [IconGlyph.LIGHT_BULB]: LightBulb,
  [IconGlyph.EYE]: Eye,
  [IconGlyph.EYE_OFF]: EyeOff,
  [IconGlyph.LABEL_AI_BORDERED]: LabelAIBordered,
  [IconGlyph.LIGHTNING]: Lightning,
  [IconGlyph.WARNING]: Warning,
  [IconGlyph.WARNING2]: Warning2,
  [IconGlyph.ACADEMIC_CAP]: AcademicCap,
  [IconGlyph.BRIEFCASE]: Briefcase,
  [IconGlyph.SEND]: Send,
  [IconGlyph.TEXT_BOLD]: TextBold,
  [IconGlyph.TEXT_ITALIC]: TextItalic,
  [IconGlyph.TEXT_UNDERLINE]: TextUnderline,
  [IconGlyph.TEXT_HIGHLIGHT]: TextHighlight,
  [IconGlyph.LIST_BULLETED]: ListBulleted,
  [IconGlyph.LIST_ORDERED]: ListOrdered,
  [IconGlyph.TEXT_UNDO]: TextUndo,
  [IconGlyph.TEXT_REDO]: TextRedo,
  [IconGlyph.TEXT_PASTE]: TextPaste,
  [IconGlyph.UPLOAD_FILE_V2]: UploadFileV2,
  [IconGlyph.HEADING]: Heading,
  [IconGlyph.LAYERS]: Layers,
  [IconGlyph.CODE]: Code,
  [IconGlyph.SCAN]: Scan,
  [IconGlyph.EXPAND]: Expand,
  [IconGlyph.COLLAPSE]: Collapse,
  [IconGlyph.LIKE]: Like,
  [IconGlyph.DISLIKE]: Dislike,
  [IconGlyph.LIKE_FILLED]: LikeFilled,
  [IconGlyph.DISLIKE_FILLED]: DislikeFilled,
  [IconGlyph.FACT_CHECKER]: FactChecker,
  [IconGlyph.GRAMMAR_CHECKER]: GrammarChecker,
  [IconGlyph.RESCAN]: Rescan,
  [IconGlyph.CROSS_CIRCLE]: CrossCircle,
  [IconGlyph.SECURE]: Secure,
  [IconGlyph.INCOGNITO]: Incognito,
  [IconGlyph.UNLOCK]: Unlock,
  [IconGlyph.AI]: Ai,
  [IconGlyph.IMPROVE_TEXT]: ImproveText,
  [IconGlyph.ASK]: Ask,
  [IconGlyph.CHAT_GPT]: ChatGpt,
  [IconGlyph.CLAUDE]: Claude,
  [IconGlyph.GEMINI]: Gemini,
  [IconGlyph.SETTINGS]: Settings,
  [IconGlyph.HUMANIZER]: Humanizer,
  [IconGlyph.AI_CHAT]: AiChat,
  [IconGlyph.DOCUMENT_SPARKLE]: DocumentSparkle,
  [IconGlyph.MICROPHONE]: Microphone,
  [IconGlyph.LINES_SPARKLE]: LinesSparkle,
  [IconGlyph.DOCUMENT_RELOAD]: DocumentReload,
  [IconGlyph.CLIP]: Clip,
  [IconGlyph.CHEVRON_DOWN]: ChevronDown,
  [IconGlyph.UNLOCK_OPEN]: UnlockOpen,
  [IconGlyph.CHEVRONS_RIGHT]: ChevronsRight,
  [IconGlyph.CHECK_MARK]: CheckMark,
  [IconGlyph.DOCUMENT_EDIT]: DocumentEdit,
  [IconGlyph.CLOCK_PLUS]: ClockPlus,
  [IconGlyph.CLOCK]: Clock,
  [IconGlyph.ALARM_CLOCK]: AlarmClock,
  [IconGlyph.DOCUMENT_TEXT]: DocumentText,
  [IconGlyph.EDIT_SQUARE]: EditSquare,
  [IconGlyph.SEARCH]: Search,
  [IconGlyph.NAV_ALL_TOOLS]: NavAllTools,
  [IconGlyph.NAV_HUMANIZER]: NavHumanizer,
  [IconGlyph.NAV_DETECTOR]: NavDetector,
  [IconGlyph.NAV_PLAGIARISM]: NavPlagiarism,
  [IconGlyph.NAV_GRAMMAR]: NavGrammar,
  [IconGlyph.NAV_AI_CHAT]: NavAiChat,
  [IconGlyph.NAV_EXPERT_HELP]: NavExpertHelp,
  [IconGlyph.NAV_HISTORY]: NavHistory,
  [IconGlyph.MORE]: More,
  [IconGlyph.BURGER]: Burger,
  [IconGlyph.CYCLE]: Cycle,
  [IconGlyph.INFINITY]: InfinitySign,
  [IconGlyph.FILE_LINES]: FileLines,
  [IconGlyph.SPARKLES]: Sparkles,
  [IconGlyph.SEARCH_SPARKLE]: SearchSparkle,
  [IconGlyph.PUZZLE_PLUS]: PuzzlePlus,
  [IconGlyph.LOCK_KEYHOLE_OPEN]: LockKeyholeOpen,
  [IconGlyph.PEN_SPARKLE]: PenSparkle,
};

export type IconProps = {
  size?: number;
  glyph: IconGlyph;
  strokeWidth?: number;
  className?: string;
};

const Icon: React.FC<IconProps> = ({ glyph, ...restProps }) => {
  const Component = icons[glyph];
  return <Component {...restProps} />;
};

export default Icon;
